package com.nonopn.skydome.common.app.api.model

import com.nonopn.skydome.common.app.detection.ThunderDetection
import kotlinx.serialization.Serializable

@Serializable
data class DashboardImpactReport(
    val probe: ThunderDetection,
    val periods: Map<DashboardImpactPeriod, PeriodReport>,
    val bestDayDate: String,
    val bestDayCount: Int,
    val countMonth: Map<String, Int>,
    val countYear: Map<String, Int>,
    val intensityBands: Map<String, NegPosCount>,
) {
    @Serializable
    enum class DashboardImpactPeriod {
        Today,
        Month,
        Quarter,
        Year,
    }

    @Serializable
    data class NegPosCount(
        val negative: Int,
        val positive: Int,
    )

    @Serializable
    data class PeriodReport(
        val total: Int,
        val stats: Stats,
        val maxPositiveDate: String,
        val maxNegativeDate: String,
    )

    @Serializable
    data class Stats(
        val pos: StatsPolarity? = null,
        val negs: StatsPolarity? = null
    )

    @Serializable
    data class StatsPolarity(
        val count: Int = 0,
        val avg: Double = 0.0,
        val median: Int = 0,
        val max: Int = 0,
    )
}
